// src/Components/Common/DataTableShell.tsx
// Shell bảng dùng chung cho toàn bộ trang danh sách trong hệ thống — style (wrapper/table/thead)
// lấy theo màn /issuance-plans, đồng bộ cho tất cả các trang (mục 8.7, READE.md). Mỗi trang tự
// quản lý nội dung cột (kể cả điều kiện hiển thị, độ rộng cột) qua headerRow/children — component
// này chỉ chịu trách nhiệm phần khung/style dùng chung, để sau này đổi style chỉ cần sửa 1 chỗ.

import React from 'react';

interface DataTableShellProps {
  /** 1 thẻ <tr> hoàn chỉnh chứa các <th> — tự quản lý cột, độ rộng, điều kiện hiển thị */
  headerRow: React.ReactNode;
  /** Các thẻ <tr> của phần dữ liệu (bao gồm cả trạng thái loading/rỗng) */
  children: React.ReactNode;
  /** 1 thẻ <tr> tuỳ chọn cho <tfoot> (VD: dòng tổng cộng) — hiếm dùng, chỉ vài trang có */
  footerRow?: React.ReactNode;
}

const DataTableShell: React.FC<DataTableShellProps> = ({ headerRow, children, footerRow }) => (
  <div className="table-responsive table-card mb-1">
    <table className="table align-middle table-nowrap mb-0">
      <thead className="table-light text-muted text-uppercase">{headerRow}</thead>
      <tbody>{children}</tbody>
      {footerRow && <tfoot className="table-light">{footerRow}</tfoot>}
    </table>
  </div>
);

/**
 * Số thứ tự (STT) tăng liên tục theo toàn danh sách, KHÔNG reset theo trang (mục 8.7, READE.md):
 * trang 2 với pageSize=20 bắt đầu từ 21, không phải 1.
 * @param pageIndex trang hiện tại, bắt đầu từ 1
 * @param pageSize số bản ghi/trang
 * @param rowIndexInPage vị trí dòng trong trang hiện tại, bắt đầu từ 0
 */
export const getSttNumber = (pageIndex: number, pageSize: number, rowIndexInPage: number): number =>
  (Math.max(pageIndex, 1) - 1) * Math.max(pageSize, 0) + rowIndexInPage + 1;

export default DataTableShell;
